export default __webpack_public_path__ + "static/media/Picture5.597c6f99.png";